import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import SimpleModal from 'components/SimpleModal';
import CalendarIntegrationContent from 'components/UserCalendarIntegration/CalendarIntegrationContent';
import { useFetchMyCalendarSettings } from 'components/UserCalendarIntegration/hooks/useFetchMyCalendarSettings';
import { jsx as _jsx } from "react/jsx-runtime";
function MindsetManageCalendarModal(_ref) {
  var onClose = _ref.onClose,
    onCalendarLinked = _ref.onCalendarLinked,
    defaultProvider = _ref.defaultProvider;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useFetchMyCalendarSe = useFetchMyCalendarSettings(),
    data = _useFetchMyCalendarSe.data;
  var wasLinkedRef = useRef(false);
  useEffect(function () {
    var _data$hasAccountLinke;
    var isLinked = (_data$hasAccountLinke = data === null || data === void 0 ? void 0 : data.hasAccountLinked) !== null && _data$hasAccountLinke !== void 0 ? _data$hasAccountLinke : false;
    if (isLinked && !wasLinkedRef.current) {
      onCalendarLinked === null || onCalendarLinked === void 0 || onCalendarLinked();
    }
    wasLinkedRef.current = isLinked;
  }, [data === null || data === void 0 ? void 0 : data.hasAccountLinked, onCalendarLinked]);
  return /*#__PURE__*/_jsx(SimpleModal, {
    id: "mindset-manage-calendar-modal",
    title: t('actions_manage_connected_calendar'),
    onClose: onClose,
    body: /*#__PURE__*/_jsx(CalendarIntegrationContent, {
      defaultProvider: defaultProvider,
      onClose: onClose
    })
  });
}
export default MindsetManageCalendarModal;